import axios from 'axios';

const API_URL = '/api/super-admin/dashboard';

/**
 * Resumen del negocio SaaS: negocios, suscripciones, cuentas y dispositivos POS.
 * @param {{ expiryWindowDays?: number, topBusinessesLimit?: number }} [params]
 */
export const fetchPlatformOverview = async (params = {}) => {
  const { data } = await axios.get(`${API_URL}/overview`, { params });
  return data;
};

/**
 * Estado del proceso de API, base central, servidor MySQL y pool de tenants.
 */
export const fetchPlatformHealth = async () => {
  const { data } = await axios.get(`${API_URL}/health`);
  return data;
};

/**
 * Detalle de suscripciones con la ventana de vencimiento indicada.
 * @param {number} [expiryWindowDays]
 */
export const fetchPlatformSubscriptions = async (expiryWindowDays) => {
  const { data } = await axios.get(`${API_URL}/subscriptions`, {
    params: expiryWindowDays ? { expiryWindowDays } : {},
  });
  return data;
};
